export default __webpack_public_path__ + "static/media/Img207.d8575842.jpg";